import { render, staticRenderFns } from "./dialogWrapper.vue?vue&type=template&id=09c695f4&scoped=true"
import script from "./dialogWrapper.vue?vue&type=script&lang=js"
export * from "./dialogWrapper.vue?vue&type=script&lang=js"
import style0 from "./dialogWrapper.vue?vue&type=style&index=0&id=09c695f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c695f4",
  null
  
)

export default component.exports